module.exports = __webpack_public_path__ + "static/media/DSC_0017.b58055fa.jpg";